import React from "react"
import styled from "styled-components"

const StyledListContent = styled.p`
  margin-block-start: 0.2rem;
  line-height: 1.5;
`

const StyledExampleList = styled.ul`
  list-style: square;
  margin-left: 1.62em;
  padding: 0;
`

const StyledHeading = styled.p`
  font-weight: bold;
  margin-top: 1em;
  margin-bottom: 0;
`

const StyledNote = styled.p`
  font-size: 0.9em;
  margin-bottom: 0.5em;
`

export default function ListContent({
  content,
  content2 = null,
  itemList = null,
  itemHeading = null,
  itemNote = null,
}) {
  return (
    <StyledListContent>
      {content}
      {itemHeading && <StyledHeading>{itemHeading}</StyledHeading>}
      {itemNote && <StyledNote>{itemNote}</StyledNote>}
      {itemList && (
        <StyledExampleList>
          {itemList.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </StyledExampleList>
      )}
      {content2 && (
        <>
          <br />
          {content2}
        </>
      )}
    </StyledListContent>
  )
}
